module.exports = __webpack_public_path__ + "static/aquasoft-b236130aca60bcb7ded6df5a08ebb3b6.jpg";